import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {InfoButton, EditProjectButton} from './ActionButtons';
import * as serviceWorker from './serviceWorker';
import {AppContainer} from './AppContainer'
import { Auth0Provider } from '@auth0/auth0-react';

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
        domain="bright-tasking.eu.auth0.com"
        clientId="FASyMu62zwOYNGzljj0nuGjeBOM6k0dZ"
        redirectUri={window.location.origin}
    >
    <AppContainer/>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
